import {
  fetchTransactions,
  createTransaction,
  updateTransaction,
  deleteTransaction,
} from "@/api/transactions";
import { cloneDeep } from "lodash";

const getDefaultState = () => ({
  transactions: [],
});

export const transactions = {
  state: getDefaultState(),
  getters: {
    allTransactions: (state) => cloneDeep(state.transactions).reverse(),
  },
  mutations: {
    SET_TRANSACTIONS(state, transactions) {
      state.transactions = transactions;
    },
    CREATE_TRANSACTION(state, transaction) {
      state.transactions.push(transaction);
    },
    UPDATE_TRANSACTION(state, transaction) {
      const index = state.transactions.findIndex(
        (trn) => trn.id === transaction.id
      );
      if (index != -1) {
        state.transactions.splice(index, 1, transaction);
      }
    },
    DELETE_TRANSACTION(state, transaction) {
      const index = state.transactions.findIndex(
        (trn) => trn.id === transaction.id
      );
      if (index != -1) {
        state.transactions.splice(index, 1);
      }
    },
    RESET_TRANSACTIONS(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async fetchTransactions({ commit }, filters = {}) {
      try {
        const { data } = await fetchTransactions(filters);
        commit("SET_TRANSACTIONS", data);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async createTransaction({ commit }, payload) {
      try {
        const { data } = await createTransaction(payload);
        commit("CREATE_TRANSACTION", data);
        commit("UPDATE_ACCOUNT", data.account);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async updateTransaction({ commit }, { id, ...payload }) {
      try {
        const { data } = await updateTransaction(id, payload);
        commit("UPDATE_TRANSACTION", data);
        commit("UPDATE_ACCOUNT", data.account);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async deleteTransaction({ commit }, id) {
      try {
        const { data } = await deleteTransaction(id);
        commit("DELETE_TRANSACTION", { id, ...data });
        commit("UPDATE_ACCOUNT", data.account);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
